import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class IntegerService {
  filterInt(value) {
    if (/^[-+]?(\d+|Infinity)$/.test(value)) {
      const returnVal = Number(value);
      console.log('filterInt: ' + returnVal + ', type: ' + typeof returnVal);
      return returnVal;
    } else {
      const returnVal = Number(value);
      console.log('filterInt: ' + returnVal + ', type: ' + typeof returnVal);
      return NaN;
    }
  }
}
